// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__nDq0V","vLegacy":"SelectSecondary_vLegacy__2Eyax","error":"SelectSecondary_error__1824s","disabled":"SelectSecondary_disabled__3Ixs7"};